import type { ReactNode } from 'react'

import type { Highlight } from '../../api/types'
import { Standbild } from '../../components/Standbild'
import { deckblattVon } from '../../lib/deckblatt'
import { standbildAdresse } from '../../lib/video'

/**
 * **One row of a POI with a tick** (1.193.0): its cover, its title, when it
 * happened, and what stands at the end. From use, for the release: "in der
 * Form wie im Chat: zur Karte hinzufügen" -- so the row of „Link zur Karte“
 * became this component, and both lists draw it. Without `checked` there is
 * no tick (a suggestion in the release, which is opened and not ticked);
 * `disabled` greys it (a draft after the chosen time).
 */
export function PoiRow({
  highlight,
  when,
  checked,
  disabled = false,
  onToggle,
  end,
  data,
}: {
  highlight: Highlight
  when: string
  checked?: boolean
  disabled?: boolean
  onToggle?: () => void
  end?: ReactNode
  /** The marks a run asks for, as `data-…` attributes. */
  data?: Record<string, string | undefined>
}) {
  const deckblatt = deckblattVon(highlight)
  const bild = deckblatt === undefined ? null : standbildAdresse(deckblatt)
  const Tag = checked === undefined ? 'div' : 'label'
  return (
    <Tag
      className={disabled ? 'kartenlinkwahl__zeile kartenlinkwahl__zeile--aus' : 'kartenlinkwahl__zeile'}
      {...data}
    >
      {checked !== undefined && (
        <input
          type="checkbox"
          className="kartenlinkwahl__haken"
          checked={checked}
          disabled={disabled}
          onChange={onToggle}
        />
      )}
      <span className="kartenlinkwahl__bild">
        {bild !== null && <Standbild src={bild} loading="lazy" />}
      </span>
      <span className="kartenlinkwahl__name">
        {highlight.title}
        <span className="kartenlinkwahl__wann">{when}</span>
      </span>
      {end}
    </Tag>
  )
}
